import React from "react";
import { colors } from "../../../../../../../themes/Colors";
import BaseButtons from "../../../../../base-buttons/BaseButtons";
import TextInputField from "../../../../../text-input-field/TextInputField";

const VehicleOwnerPopUp = ({ display, onCloseClick, vehicalOwnerData }) => {
  return (
    <div
      style={{
        position: "absolute",
        height: display ? "100%" : 0,
        width: "100%",
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        flexDirection: "column",
        backgroundColor: colors.white,
        overflow: "hidden",
        transition: "all 0.3s",
        opacity: display ? 1 : 0,
        bottom: 0,
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 55,
          left: 10,
          display: "flex",
          alignItems: "center",
          zIndex: 1,
        }}
      >
        <BaseButtons
          label={"BACK"}
          borderRadius={8}
          onClick={onCloseClick}
          width={65}
          height={40}
          backgroundColor={colors.orangeDark}
        />
      </div>
      <div
        style={{
          //   position: "absolute",
          marginTop: 62,
          width: "100%",
          display: "flex",
          alignItems: "center",

          textAlign: "center",
          justifyContent: "center",
          fontWeight: "bold",
          fontSize: 20,
          marginBottom: 20,
        }}
      >
        VEHICLE OWNER
      </div>
      <TextInputField
        mini={true}
        labelTitle={"NAME"}
        readOnly={true}
        value={
          vehicalOwnerData
            ? vehicalOwnerData.firstName + " " + vehicalOwnerData.lastName
            : "loading"
        }
      />
      <div style={{ height: 10 }} />
      <TextInputField
        mini={true}
        labelTitle={"CELL NUMBER"}
        readOnly={true}
        value={vehicalOwnerData ? vehicalOwnerData.cellNumber : "loading"}
      />
      <div style={{ height: 10 }} />
      <TextInputField
        mini={true}
        labelTitle={"EMAIL"}
        readOnly={true}
        value={vehicalOwnerData ? vehicalOwnerData.email : "loading"}
      />
      <div style={{ height: 40 }} />
      <a
        href={`tel:${vehicalOwnerData ? vehicalOwnerData.cellNumber : "none"}`}
        style={{
          textDecorationLine: "none",
          width: "100%",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <BaseButtons
          label={"CALL NOW"}
          borderRadius={8}
          backgroundColor={colors.greenLight}
          width={"80%"}
        />
      </a>

      <div style={{ height: 20 }} />
      <BaseButtons
        label={"SEND NOTICE"}
        borderRadius={8}
        backgroundColor={colors.greenLight}
        width={"80%"}
        disabled={true}
      />
    </div>
  );
};

export default VehicleOwnerPopUp;
